import FormatUtils from '@front/squirtle/utils/format'
import { UserUtils } from '@front/volcanion/utils'

class Callbacks {
  static onSubmitHandler(getActionListener, getEventListener) {
    return function onSubmit(values) {
      const { operator, client, company, driver, vehicle, group, createdAt_start, createdAt_end } = values || {}
      const createdAt = FormatUtils.intervalFilter(createdAt_start, createdAt_end)

      const operatorFilter = !!operator ? { operator } : { operator: { '!': null } }

      const actionFilter = _.merge({},
        operatorFilter,
        !!driver && { driver },
        !!vehicle && { vehicle },
        !!group && { group },
        { createdAt }
      )

      const eventFilter = _.merge({},
        operatorFilter,
        !!client && { order: { do: client } },
        !!company && { order: { service: { contract: { company } } } },
        !!driver && { driver },
        !!vehicle && { vehicle },
        { createdAt }
      )

      return Promise.all([
        getActionListener?.()?.search(actionFilter),
        getEventListener?.()?.search(eventFilter)
      ])
    }
  }

  static autocompleteMutatorStaff() {
    return function autocompleteMutatorStaff(q) {
      return {
        or: [
          { info: { last_name: { startsWith: q } } },
          { info: { first_name: { startsWith: q } } },
          { auth: { username: { startsWith: q } } }
        ]
      }
    }
  }

  static autocompleteMutatorClient() {
    return function autocompleteMutatorClient(q) {
      return {
        or: [
          { customerinfo: { client_number: { startsWith: q } } },
          { info: { first_name: { startsWith: q } } },
          { info: { last_name: { startsWith: q } } }
        ]
      }
    }
  }

  static autocompleteMutatorDriver() {
    return function autocompleteMutatorDriver(q) {
      return {
        or: [
          { info: { user_client_id: { startsWith: q } } },
          { info: { first_name: { startsWith: q } } },
          { info: { last_name: { startsWith: q } } }
        ]
      }
    }
  }

  static autocompleteMutatorCompany() {
    return function autocompleteMutatorCompany(q) {
      return {
        or: [{ client_id: { startsWith: q } }, { name: { startsWith: q } }]
      }
    }
  }

  static autocompleteMutatorGroup() {
    return function autocompleteMutatorGroup(q) {
      return {
        or: [{ group_client_id: { startsWith: q } }, { name: { startsWith: q } }]
      }
    }
  }

  static staffMutator() {
    return function staffMutator(user) {
      return {
        label: UserUtils.getFormatedName(user?.info, { prefix: user?.auth?.username }),
        ...user
      }
    }
  }

  static clientMutator() {
    return function clientMutator(user) {
      return {
        label: UserUtils.getFormatedName({ ...user?.info, designation: user?.customerinfo?.name }, { prefix: user?.customerinfo?.client_number }),
        ...user
      }
    }
  }

  static driverMutator() {
    return function driverMutator(user) {
      return {
        label: UserUtils.getFormatedName({ ...user?.info, designation: user?.customerinfo?.name }, { prefix: user?.info?.user_client_id }),
        ...user
      }
    }
  }

  static companyMutator() {
    return function companyMutator(company) {
      return {
        label: _.compact([company?.client_id, company?.name]).join(' - '),
        ...company
      }
    }
  }

  static groupMutator() {
    return function groupMutator(group) {
      return {
        label: _.compact([group?.group_client_id, group?.name]).join(' - '),
        ...group
      }
    }
  }
}

export default Callbacks
